export default "__VITE_ASSET__6A5mWjao__"